import { render, staticRenderFns } from "./MultipleArticlesPickerPrompt.vue?vue&type=template&id=5d61f526&scoped=true&"
import script from "./MultipleArticlesPickerPrompt.vue?vue&type=script&lang=js&"
export * from "./MultipleArticlesPickerPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d61f526",
  null
  
)

export default component.exports